var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", [
    _c("div", { staticClass: "fc-text-center" }, [
      _c("img", {
        staticClass: "paystatus_img",
        attrs: { src: require("../assets/img/successIcon.png") }
      }),
      _vm._v(" "),
      _c("p", { staticClass: "paystatus_title" }, [
        _vm._v(_vm._s(_vm.$t("m.PayStatusSuccess_title")))
      ]),
      _vm._v(" "),
      _c(
        "div",
        {
          staticClass: "fc-btn-main backhomepage fc-mar-t-super",
          on: { click: _vm.goHome }
        },
        [_vm._v(_vm._s(_vm.$t("m.goBack")))]
      )
    ])
  ])
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-7edc8ca2", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-7edc8ca2","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href","audio":"src"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/pages/success.vue
// module id = null
// module chunks = 